import React, { useState } from "react";
import { Href, SplitDropdowns, Widgets } from "../../../../Constant";
import { Card, CardBody, Col, Dropdown, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SPLIT_DATA, SPLIT_LIST } from "../../../../Data/UiKit/Dropdown";
import { Btn } from "../../../../AbstractElements";
import SplitButtonDropdown from "./SplitButtonDropdown";

const SplitDropdown = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  return (
    <Col sm="12" xl="12">
      <Card>
        <CommonCardHeader title={SplitDropdowns} span={SPLIT_DATA} />
        <CardBody className="dropdown-basic me-0">
          <div className="common-flex">
            <div className="btn-group">
              <Btn color="primary" outline type="button">{Widgets}</Btn>
              <Dropdown className="separated-btn" isOpen={open} toggle={toggle}>
                <DropdownToggle color="primary"><i className="icofont icofont-arrow-down"></i></DropdownToggle>
                <div className="dropdown-content">
                  <a href={Href}>General</a>
                  <a href={Href}>Chart</a>
                </div>
              </Dropdown>
            </div>
            {SPLIT_LIST.map((data, index) => (
              <SplitButtonDropdown key={index} item={data} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SplitDropdown;
